export const formatter = (attribute) => {
    return attribute.replace(/[_.\[]/g, ' ').replace(/]/g, '');
};
export function toCamelCase(s) {
    return s.replace(/([-_][a-z])/gi, ($1) => {
        return $1.toUpperCase().replace('-', '').replace('_', '');
    });
}
export function onlyDigits(str) {
    const num = Number(str);
    return !isNaN(num) && typeof str !== 'boolean';
}
